<template>
  <el-form
    :model="form"
    ref="form">
    <!-- Supplier Quote -->
    <el-row :gutter="24">
      <el-col :lg="4" :sm="6" :span="12">
        <el-form-item
          prop="chosen"
          class="material-style margin-bottom-none"
        >
          <el-checkbox
            v-model="form.chosen"
            @change="updateModelItem('chosen', { required: false })"
          >
            {{L10n('chosen')}}
          </el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :lg="4" :sm="12" :span="12">
        <el-form-item
          :label="L10n('part')"
          prop="partID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-part-number
            :model.sync="form.partID"
            @update:model="updateModelItem('partID', { required: true })"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="4" :sm="6" :span="24">
        <el-form-item
          :label="L10n('part-sn')"
          prop="partSN"
          class="material-style"
        >
          <el-input
            :value="form.partSN"
            @input="form.partSN = valueTrimLeft($event)"
            @change="updateModelItem('partSN', { required: false })"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="2" :sm="4" :span="12">
        <el-form-item
          :label="L10n('qty')"
          prop="qty"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"
            @change="updateModelItem('qty', { required: true })"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="2" :sm="4" :span="12">
        <el-form-item
          :label="L10n('price')"
          prop="price"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.price"
            @input="form.price = valueNumber($event)"
            @change="updateModelItem('price', { required: true })"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="4"  :sm="8" :span="12">
        <el-form-item
          prop="currencyID"
          :label="L10n('currency')"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-response
            :model.sync="form.currencyID"
            @update:model="updateModelItem('currencyID', { required: true })"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="4" :sm="8" :span="12">
        <el-form-item
          :label="L10n('payment-term')"
          prop="paymentTermID"
          class="material-style">
          <select-response
            :model.sync="form.paymentTermID"
            @update:model="updateModelItem('paymentTermID', { required: false })"
            :isLoading="dataSourcePaymentTerm.loading"
            :data="dataSourcePaymentTerm.records"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <div class="row">
      <div class="col-xl-2 col-sm-6 col-12">
        <el-form-item
          :label="L10n('supplier')"
          prop="supplierCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.supplierCompanyID"
            @on-created="mixCreateSupplier"
            @on-change="(id) => mixChangeSupplierID(id, { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-xl-4 col-sm-6 col-12">
        <el-form-item
          :label="L10n('supplier-contact')"
          prop="supplierContactID"
          class="material-style">
          <select-company-contact
            :model.sync="form.supplierContactID"
            :companyID="form.supplierCompanyID"
            @update:model="updateModelItem('supplierContactID', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-xl-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          class="material-style"
        >
          <select-response
            :model.sync="form.conditionID"
            @update:model="updateModelItem('conditionID', { required: false })"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          />
        </el-form-item>
      </div>
      <div class="col-xl-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('release')"
          prop="releaseID"
          class="material-style"
        >
          <select-response
            :model.sync="form.releaseID"
            @update:model="updateModelItem('releaseID', { required: false })"
            :data="dataSourceRelease.records"
            :isLoading="dataSourceRelease.loading"
          />
        </el-form-item>
      </div>
    </div>
    <view-more>
      <div class="row">
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('employee')"
            prop="employeeID"
            class="material-style">
            <select-response
              :model.sync="form.employeeID"
              @update:model="updateModelItem('employeeID')"
              :disabled="disabledEmployee"
              :data="dataSourceEmployee.records"
              :isLoading="dataSourceEmployee.isLoading"
            />
          </el-form-item>
        </div>
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('delivery')"
            prop="delivery"
            class="material-style"
            :rules="getValidationRule('number')"
          >
            <el-input
              :value="form.delivery"
              @input="form.delivery = valueNumber($event)"
              @change="updateModelItem('delivery', { required: false })"
            />
          </el-form-item>
        </div>
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('traceability-company')"
            prop="traceabilityCompanyID"
            class="material-style"
          >
            <select-company
              :model.sync="form.traceabilityCompanyID"
              @update:model="updateModelItem('traceabilityCompanyID', { required: false })"
            />
          </el-form-item>
        </div>
        <div class="col-xl-3 col-md-6 col-12">
          <el-form-item
            :label="L10n('estimated-delivery-date')"
            prop="estimatedDeliveryDate"
            class="material-style"
          >
            <date-picker
              v-model="form.estimatedDeliveryDate"
              @change="updateModelItem('estimatedDeliveryDate', { required: false })"
            />
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-12">
          <el-form-item
            :label="L10n('tag-info-company')"
            prop="tagInfoCompanyID"
            class="material-style"
          >
            <select-company
              :model.sync="form.tagInfoCompanyID"
              @update:model="updateModelItem('tagInfoCompanyID', { required: false })"
            />
          </el-form-item>
        </div>
        <div class="col-md-3 col-12">
          <el-form-item
            :label="L10n('tag-date')"
            prop="tagDate"
            class="material-style"
          >
            <date-picker
              v-model="form.tagDate"
              @change="updateModelItem('tagDate', { required: false })"
            />
          </el-form-item>
        </div>
        <div class="col-md-6 col-12">
          <el-form-item
            :label="L10n('remarks')"
            prop="remarks"
            class="material-style"
          >
            <el-input
              :value="form.remarks"
              @input="form.remarks = valueTrimLeft($event)"
              @change="updateModelItem('remarks', { required: false })"
            />
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-12">
          <el-form-item
            :label="L10n('type-of-operation')"
            prop="typeOfOperationConditionID"
            class="material-style"
          >
            <select-response
              :model.sync="form.typeOfOperationConditionID"
              @update:model="updateModelItem('typeOfOperationConditionID', { required: false })"
              :isLoading="dataSourceCondition.loading"
              :data="dataSourceCondition.records"
            />
          </el-form-item>
        </div>
        <div class="col-md-3 col-12">
          <el-form-item
            :label="L10n('reason-for-removal')"
            prop="reasonForRemoval"
            class="material-style"
          >
            <el-input
              :value="form.reasonForRemoval"
              @input="form.reasonForRemoval = valueTrimLeft($event)"
              @change="updateModelItem('reasonForRemoval', { required: false })"
            />
          </el-form-item>
        </div>
        <div class="col-md-3 col-12">
          <el-form-item
            :label="L10n('received-date')"
            prop="receivedDate"
            class="material-style"
          >
            <date-picker
              v-model="form.receivedDate"
              @change="updateModelItem('receivedDate', { required: false })"
            />
          </el-form-item>
        </div>
        <div class="col-md-3 col-12">
          <el-form-item
            prop="warrantyRequested"
            class="material-style"
          >
            <el-checkbox
              v-model="form.warrantyRequested"
              @change="updateModelItem('warrantyRequested', { required: false })"
            >
              {{L10n('warranty-requested')}}
            </el-checkbox>
          </el-form-item>
        </div>
      </div>
      <form-controls
        isSave
        isDelete
        @command="command($event)"
      />
    </view-more>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import mixListForm from '@/components/ListForm/mixForm'
import { mixUpdateSupplier } from '@/mixins/companies'
export default {
  name: 'FormSupplierQuoteRFQ',
  mixins: [mixListForm, Form, mixUpdateSupplier],
  components: {
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue')
  },
  computed: {
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceRelease () {
      return this.API('Releases/GetAllDynamic?select=id,title')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    },
    disabledEmployee () {
      return !this.$store.getters.isHighPermission
    }
  },
  methods: {
    command (command) {
      this.$emit('command', command)
    }
  }
}
</script>
